import React, { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'

interface PasswordInputProps {
  id: string
  name?: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  required?: boolean
  autoComplete?: string
  className?: string
  error?: boolean
  disabled?: boolean
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  id,
  name,
  value,
  onChange,
  placeholder = "Password",
  required = false,
  autoComplete = "current-password",
  className = "",
  error = false,
  disabled = false
}) => {
  const [showPassword, setShowPassword] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className="relative">
      <input
        id={id}
        name={name}
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete}
        disabled={disabled}
        className={`
          w-full px-4 py-3 pr-12
          bg-dark-secondary/50
          border border-dark-tertiary/30
          rounded-lg
          text-light-primary
          placeholder-light-tertiary
          backdrop-blur-sm
          focus:outline-none
          focus:ring-2
          focus:ring-primary-500/50
          focus:border-primary-500
          transition-all duration-200
          disabled:opacity-50 disabled:cursor-not-allowed
          ${error ? 'border-red-500 focus:ring-red-500/50 focus:border-red-500' : ''}
          ${className}
        `}
      />
      <button
        type="button"
        onClick={togglePasswordVisibility}
        className="
          absolute right-3 top-1/2 -translate-y-1/2
          text-light-tertiary hover:text-light-secondary
          transition-colors duration-200
          p-1 rounded
          focus:outline-none
          focus:ring-2
          focus:ring-primary-500/50
        "
        aria-label={showPassword ? "Hide password" : "Show password"}
      >
        {showPassword ? (
          <EyeOff className="w-5 h-5" />
        ) : (
          <Eye className="w-5 h-5" />
        )}
      </button>
    </div>
  )
}